import { FiBookmark } from "react-icons/fi"
import { MdFavoriteBorder, MdOutlineVisibility } from "react-icons/md"

export const navbarItems = [
  {
    title: "favorites",
    path: "/favourites",
    icon: MdFavoriteBorder,
  },
  {
    title: "saved",
    path: "/saves",
    icon: FiBookmark,
  },
  {
    title: "viewed",
    path: "/views",
    icon: MdOutlineVisibility,
  },
]
